import { useState, useEffect, useContext } from 'react'
import EnvContext from '../context/EnvContext'

import { gql, useQuery } from '@apollo/client';
import { THREE_MINUTES } from './pollIntervals'


const ACCOUNT_QUERY = gql`
query($envName: String!) {
    account(where: {environment: {name: {_eq: $envName}}}) {
        id
        parentId
        accountName
        AOTCTypeId
        AOTCTypeInherited
        disabledByAutoliquidate
        disabledByOrderLimit
        rev
        tradingAllowed
        tradingAllowedSelf
        tradingAllowedSubs
        typeId
        companyId
        environment {
            name
        }
    }
}
`

export const useTTUSAccount = () => {

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(ACCOUNT_QUERY, {
        variables: {
            "envName": envSelected,
        },
        pollInterval: THREE_MINUTES
    })



    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.account.reduce((acc, d) => {
                if (d)
                    acc[d.id] = {
                        'id': d.id,
                        'parentId': d.parentId === -1 ? null : d.parentId,
                        'name': d.accountName,
                        'rev': d.rev,
                        'AOTCTypeId': d.AOTCTypeId === -1 ? null : d.AOTCTypeId,
                        'AOTCTypeInherited': d.AOTCTypeInherited === -1 ? null : d.AOTCTypeInherited,
                        'disabledByAutoliquidate': d.disabledByAutoliquidate === -1 ? null : d.disabledByAutoliquidate,
                        'disabledByOrderLimit': d.disabledByOrderLimit === -1 ? null : d.disabledByOrderLimit,
                        'tradingAllowed': d.tradingAllowed === -1 ? null : d.tradingAllowed,
                        'tradingAllowedSelf': d.tradingAllowedSelf === -1 ? null : d.tradingAllowedSelf,
                        'tradingAllowedSubs': d.tradingAllowedSubs === -1 ? null : d.tradingAllowedSubs,
                        'typeId': d.typeId,
                        'companyId': d.companyId,
                        'environment': d.environment.name,
                    }
                return acc
            }, {}))
        }
    }, [data, loading])

    return lookupData
}

export const useTTUSAccountExact = (id) => {

    const ACCOUNT_QUERY_EXACT = gql`
    query($envName: String!, $id: bigint!) {
        account(where: {environment: {name: {_eq: $envName}}, id: {_eq: $id}}) {
            id
            parentId
            accountName
            AOTCTypeId
            AOTCTypeInherited
            disabledByAutoliquidate
            disabledByOrderLimit
            rev
            tradingAllowed
            tradingAllowedSelf
            tradingAllowedSubs
            typeId
            companyId
            environment {
                name
            }
        }
    }
    `

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(ACCOUNT_QUERY_EXACT, {
        variables: {
            "envName": envSelected,
            "id": id
        }
    })



    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.account.reduce((acc, d) => {
                if (d)
                    acc[d.id] = {
                        'id': d.id,
                        'parentId': d.parentId === -1 ? null : d.parentId,
                        'name': d.accountName,
                        'rev': d.rev,
                        'AOTCTypeId': d.AOTCTypeId === -1 ? null : d.AOTCTypeId,
                        'AOTCTypeInherited': d.AOTCTypeInherited === -1 ? null : d.AOTCTypeInherited,
                        'disabledByAutoliquidate': d.disabledByAutoliquidate === -1 ? null : d.disabledByAutoliquidate,
                        'disabledByOrderLimit': d.disabledByOrderLimit === -1 ? null : d.disabledByOrderLimit,
                        'tradingAllowed': d.tradingAllowed === -1 ? null : d.tradingAllowed,
                        'tradingAllowedSelf': d.tradingAllowedSelf === -1 ? null : d.tradingAllowedSelf,
                        'tradingAllowedSubs': d.tradingAllowedSubs === -1 ? null : d.tradingAllowedSubs,
                        'typeId': d.typeId,
                        'companyId': d.companyId,
                        'environment': d.environment.name,
                    }
                return acc
            }, {}))
        }
    }, [data, loading])

    return lookupData
}


export const useTTUSParentAccount = () => {

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(ACCOUNT_QUERY, {
        variables: {
            "envName": envSelected,
        }, pollInterval: THREE_MINUTES
    })



    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.account.reduce((acc, d) => {
                if (d && d.parentId !== -1)
                    acc[d.parentId] = {
                        'id': d.id,
                        'parentId': d.parentId === -1 ? null : d.parentId,
                        'name': d.accountName,
                        'rev': d.rev,
                        'AOTCTypeId': d.AOTCTypeId === -1 ? null : d.AOTCTypeId,
                        'AOTCTypeInherited': d.AOTCTypeInherited === -1 ? null : d.AOTCTypeInherited,
                        'disabledByAutoliquidate': d.disabledByAutoliquidate === -1 ? null : d.disabledByAutoliquidate,
                        'disabledByOrderLimit': d.disabledByOrderLimit === -1 ? null : d.disabledByOrderLimit,
                        'tradingAllowed': d.tradingAllowed === -1 ? null : d.tradingAllowed,
                        'tradingAllowedSelf': d.tradingAllowedSelf === -1 ? null : d.tradingAllowedSelf,
                        'tradingAllowedSubs': d.tradingAllowedSubs === -1 ? null : d.tradingAllowedSubs,
                        'typeId': d.typeId,
                        'companyId': d.companyId,
                        'environment': d.environment.name,
                    }
                return acc
            }, {}))
        }
    }, [data, loading])

    return lookupData
}

